<template>
  <div>
    <multiselect
      class="form-control"
      v-model="modelo.gestion"
      :options="datos"
      track-by="gestion"
      label="gestion"
      :searchable="false"
      :close-on-select="true"
      :hide-selected="true"
      :show-labels="false"
      placeholder="Seleccione..."
    ></multiselect>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: { model: Object, todos: { type: Boolean, required: false, default: false } },
  data() {
    return {
      //   datos: [],
      modelo: {
        gestion: null,
      },
    };
  },
  watch: {
    'modelo.gestion': function () {
      this.model.gestion = this.modelo.gestion;
    },
    default(a) {
      this.modelo.gestion = a;
    },
  },
  computed: {
    ...mapState({ datos: (state) => state.gestion.items, default: (state) => state.gestion.value }),
  },
};
</script>